<template>
    <div>
        <el-dialog :title="titleDialog"
                   :visible="showDialog"
                   @open="create" width="60%"
                   :close-on-click-modal="false"
                   :close-on-press-escape="false"
                   :show-close="false">
            <div class="row">
                <div class="col text-center font-weight-bold">
                    <p>Imprimir A4</p>
                    <button type="button" class="btn btn-lg btn-info waves-effect waves-light"
                            @click="clickToPrint('a4')">
                        <i class="fa fa-file-alt"></i>
                    </button>
                </div>
                <div class="col text-center font-weight-bold">
                    <p>Imprimir A5</p>
                    <button type="button" class="btn btn-lg btn-info waves-effect waves-light"
                            @click="clickToPrint('a5')">
                        <i class="fa fa-file-alt"></i>
                    </button>
                </div>
                <div class="col text-center font-weight-bold">
                    <p>Imprimir Ticket</p>
                    <button type="button" class="btn btn-lg btn-info waves-effect waves-light"
                            @click="clickToPrint('ticket')">
                        <i class="fa fa-receipt"></i>
                    </button>
                </div>
                <template v-if="configuration">
                    <div class="col text-center font-weight-bold" v-if="configuration.ticket_58">
                        <p>Imprimir Ticket 58MM</p>
                        <button type="button" class="btn btn-lg btn-info waves-effect waves-light"
                                @click="clickToPrint('ticket_58')">
                            <i class="fa fa-receipt"></i>
                        </button>
                    </div>
                </template>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <el-input v-model="form.customer_email">
                        <el-button slot="append"
                                   icon="el-icon-message"
                                   @click="clickSendEmail"
                                   :loading="loading">
                            Enviar
                        </el-button>
                    </el-input>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="clickFinalize">Ir al listado</el-button>
                <el-button type="primary" @click="clickNewOrderNote">Nuevo pedido</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>

export default {
    props: [
        "showDialog",
        "recordId",
        "showClose",
        "showGenerate",
        "type",
        'typeUser',
        'configuration'
    ],
    data() {
        return {
            loading: false,
            titleDialog: '',
            resource: "order-notes",
            errors: {},
            form: {},
        };
    },
    created() {
        this.initForm()
    },
    methods: {
        initForm() {
            this.errors = {}
            this.form = {}
        },
        create() {
            this.initForm()
            this.getRecord()
        },
        async getRecord() {
            this.loading = true
            await this.$http.get(`/${this.resource}/record2/${this.recordId}`)
                .then((response) => {
                    this.form = response.data.data;
                    let type = this.type === "edit" ? "editada" : "registrada";
                    this.titleDialog = `Cotización ${type}: ` + this.form.identifier;
                })
                .finally(() => {
                    this.loading = false
                })
        },
        clickCancel(index) {
            this.document.payments.splice(index, 1);
        },
        clickFinalize() {
            location.href = `/${this.resource}`;
        },
        clickNewOrderNote() {
            this.clickClose()
        },
        clickClose() {
            this.$emit("update:showDialog", false)
        },
        clickToPrint(format) {
            window.open(`/${this.resource}/print/${this.form.external_id}/${format}`, "_blank")
        },
        async clickSendEmail() {
            this.loading = true;
            await this.$http.post(`/${this.resource}/email`, {
                customer_email: this.customer_email,
                id: this.form.id,
                customer_id: this.form.order_note.customer_id
            })
                .then(response => {
                    if (response.data.success) {
                        this.$message.success("El correo fue enviado satisfactoriamente");
                    } else {
                        this.$message.error("Error al enviar el correo");
                    }
                })
                .catch(error => {
                    this.$message.error("Error al enviar el correo");
                })
                .finally(() => {
                    this.loading = false
                })
        }
    }
};
</script>
